import {NgModule} from '@angular/core';
import {Scan3dGroupSummaryConverter} from './api/entity/converter/scan3dGroupSummary.converter';
import {Scan3dGroupConverter} from './api/entity/converter/scan3dGroup.converter';
import {Scan3dGroupRepository} from './impl/service/ngrx/scan3dGroup.repository';
import {Scan3dGroupDataServiceAdapter} from './impl/service/ngrx/scan3dGroupDataService.adapter';
import {Scan3dGroupSummaryDataServiceAdapter} from './impl/service/ngrx/scan3dGroupSummaryDataService.adapter';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {Scan3dGroupDataService} from './impl/service/ngrx/scan3dGroupData.service';

@NgModule({
    providers: [
        Scan3dGroupSummaryConverter,
        Scan3dGroupConverter,

        Scan3dGroupRepository,
        Scan3dGroupDataService,
        Scan3dGroupDataServiceAdapter,
        Scan3dGroupSummaryDataServiceAdapter,
    ],
})
export class Scan3dGroupModule {
     constructor(entityDataService: EntityDataService,
                 entityServices: EntityServices,
                 repository: Scan3dGroupRepository,
                 dataService: Scan3dGroupDataService,
    ) {

        entityDataService.registerServices({
            Scan3dGroup: dataService,
        });

        entityServices.registerEntityCollectionServices({
            Scan3dGroup: repository,
        });

        // errorMessages.set(PARTNER_SAVE_PERSON_ALREADY_PART_OF_THIS_TYPE, 'La personne sélectionnée est déjà %1');
    }
}
